// extracted by mini-css-extract-plugin
module.exports = {"primary-sector":"antd-pro-pages-home-county-contacts-department-primary-sector-index-primary-sector"};